import React, { useState } from 'react'

const Loader = () => (
  <div className="cgt-icon cgt-icon__icon cgt-icon--default cgt-icon--primary">
    <div className="cgt-spinner cgt-spinner--xsmall" />
  </div>
)

const noticeSpacing = `cgt-mt-10 cgt-mb-10 cgt-ml-10 cgt-mr-10
  cgt-notice-outline cgt-notice-outline--primary is-medium
  cgt-notice-outline--thick`

function VerifyNotice() {
  const [isChecking, setIsChecking] = useState(false)

  function checkVerification() {
    setIsChecking(true)

    window.axios.get('/guests/sessions/guest_verified').then((response) => {
      setIsChecking(false)

      if (response && response.data && response.data.verified) {
        return window.location = `/${window.location.pathname.split('/')[1]}/checkout/payment`
      }

      return App.events.publish('app:notification:flash:error', 'Email is not yet verified!')
    })
  }

  return (
    <div className={`${noticeSpacing}`}>
      <div className="cgt-notice__content">
        We've sent you a verification email, please check your email and submit it!
      </div>
      <button
        onClick={checkVerification}
        disabled={isChecking}
        type="button"
        className="cgt-button cgt-button--primary cgt-button--medium cgt-button--with-icon"
      >
        <span>Check verification</span>
        {isChecking && <Loader />}
      </button>
    </div>
  )
}

export default VerifyNotice
